var exports = {
  "k": "container__XV5lTK",
  "p": "list__vCph0B",
};

module.exports = exports;
